import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://6890aa72a01b477cc68951018105256d@o4510878649810944.ingest.de.sentry.io/4510878659641424",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.feedbackIntegration({
      colorScheme: "system",
      isNameRequired: false,
      isEmailRequired: true,
      autoInject: false,
    }),
  ],
  // On localhost, only send user-submitted feedback — drop auto-captured errors
  beforeSend(event) {
    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
      return null;
    }
    return event;
  },
});

import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { all } from "@awesome.me/kit-8789beac8f/icons";

// Initialize FontAwesome
library.add(...all);
createRoot(document.getElementById("root")!).render(<App />);
